import { createComponent as _$createComponent } from "@opentui/solid";
import { effect as _$effect } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { TextAttributes } from "@opentui/core";
import { useTheme } from "../context/theme";
import { useDialog } from "./dialog";
import { useKeyboard } from "@opentui/solid";
export function DialogAlert(props) {
  const dialog = useDialog();
  const {
    theme
  } = useTheme();
  useKeyboard(evt => {
    if (evt.name === "return") {
      props.onConfirm?.();
      dialog.clear();
    }
  });
  return (() => {
    var _el$ = _$createElement("box"),
      _el$2 = _$createElement("box"),
      _el$3 = _$createElement("text"),
      _el$4 = _$createElement("text"),
      _el$6 = _$createElement("box"),
      _el$7 = _$createElement("text"),
      _el$8 = _$createElement("box"),
      _el$9 = _$createElement("box"),
      _el$0 = _$createElement("text");
    _$insertNode(_el$, _el$2);
    _$insertNode(_el$, _el$6);
    _$insertNode(_el$, _el$8);
    _$setProp(_el$, "paddingLeft", 2);
    _$setProp(_el$, "paddingRight", 2);
    _$setProp(_el$, "gap", 1);
    _$insertNode(_el$2, _el$3);
    _$insertNode(_el$2, _el$4);
    _$setProp(_el$2, "flexDirection", "row");
    _$setProp(_el$2, "justifyContent", "space-between");
    _$insert(_el$3, () => props.title);
    _$insertNode(_el$4, _$createTextNode(`esc`));
    _$setProp(_el$4, "onMouseUp", () => dialog.clear());
    _$insertNode(_el$6, _el$7);
    _$setProp(_el$6, "paddingBottom", 1);
    _$insert(_el$7, () => props.message);
    _$insertNode(_el$8, _el$9);
    _$setProp(_el$8, "flexDirection", "row");
    _$setProp(_el$8, "justifyContent", "flex-end");
    _$setProp(_el$8, "paddingBottom", 1);
    _$insertNode(_el$9, _el$0);
    _$setProp(_el$9, "paddingLeft", 3);
    _$setProp(_el$9, "paddingRight", 3);
    _$setProp(_el$9, "onMouseUp", () => {
      props.onConfirm?.();
      dialog.clear();
    });
    _$insertNode(_el$0, _$createTextNode(`ok`));
    _$effect(_p$ => {
      var _v$ = TextAttributes.BOLD,
        _v$2 = theme.text,
        _v$3 = theme.textMuted,
        _v$4 = theme.textMuted,
        _v$5 = theme.primary,
        _v$6 = theme.selectedListItemText;
      _v$ !== _p$.e && (_p$.e = _$setProp(_el$3, "attributes", _v$, _p$.e));
      _v$2 !== _p$.t && (_p$.t = _$setProp(_el$3, "fg", _v$2, _p$.t));
      _v$3 !== _p$.a && (_p$.a = _$setProp(_el$4, "fg", _v$3, _p$.a));
      _v$4 !== _p$.o && (_p$.o = _$setProp(_el$7, "fg", _v$4, _p$.o));
      _v$5 !== _p$.i && (_p$.i = _$setProp(_el$9, "backgroundColor", _v$5, _p$.i));
      _v$6 !== _p$.n && (_p$.n = _$setProp(_el$0, "fg", _v$6, _p$.n));
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined,
      n: undefined
    });
    return _el$;
  })();
}
DialogAlert.show = (dialog, title, message) => {
  return new Promise(resolve => {
    dialog.replace(() => _$createComponent(DialogAlert, {
      title: title,
      message: message,
      onConfirm: () => resolve()
    }), () => resolve());
  });
};